// Public FAQ constants
export const PUBLIC_FAQS_REQUEST = "PUBLIC_FAQS_REQUEST";
export const PUBLIC_FAQS_SUCCESS = "PUBLIC_FAQS_SUCCESS";
export const PUBLIC_FAQS_FAIL = "PUBLIC_FAQS_FAIL";

// Admin FAQ list constants
export const ADMIN_FAQS_REQUEST = "ADMIN_FAQS_REQUEST";
export const ADMIN_FAQS_SUCCESS = "ADMIN_FAQS_SUCCESS";
export const ADMIN_FAQS_FAIL = "ADMIN_FAQS_FAIL";

// FAQ details constants
export const FAQ_DETAILS_REQUEST = "FAQ_DETAILS_REQUEST";
export const FAQ_DETAILS_SUCCESS = "FAQ_DETAILS_SUCCESS";
export const FAQ_DETAILS_FAIL = "FAQ_DETAILS_FAIL";

// New FAQ constants
export const NEW_FAQ_REQUEST = "NEW_FAQ_REQUEST";
export const NEW_FAQ_SUCCESS = "NEW_FAQ_SUCCESS";
export const NEW_FAQ_FAIL = "NEW_FAQ_FAIL";
export const NEW_FAQ_RESET = "NEW_FAQ_RESET";

// FAQ update constants
export const FAQ_UPDATE_REQUEST = "FAQ_UPDATE_REQUEST";
export const FAQ_UPDATE_SUCCESS = "FAQ_UPDATE_SUCCESS";
export const FAQ_UPDATE_FAIL = "FAQ_UPDATE_FAIL";
export const FAQ_UPDATE_RESET = "FAQ_UPDATE_RESET";

// FAQ delete constants
export const FAQ_DELETE_REQUEST = "FAQ_DELETE_REQUEST";
export const FAQ_DELETE_SUCCESS = "FAQ_DELETE_SUCCESS";
export const FAQ_DELETE_FAIL = "FAQ_DELETE_FAIL";
export const FAQ_DELETE_RESET = "FAQ_DELETE_RESET";

// FAQ status toggle constants
export const FAQ_STATUS_REQUEST = "FAQ_STATUS_REQUEST";
export const FAQ_STATUS_SUCCESS = "FAQ_STATUS_SUCCESS";
export const FAQ_STATUS_FAIL = "FAQ_STATUS_FAIL";
export const FAQ_STATUS_RESET = "FAQ_STATUS_RESET";

// Clear errors
export const CLEAR_ERRORS = "CLEAR_ERRORS";
 